export const getAllCompanyUsers = (state) => state.user.users;
export const getAllCompanyUsersStatus = (state) => state.user.status;
export const getAllCompanyUsersError = (state) => state.user.error;

export const addUserStatus = (state) => state.user.addUserStatus;
export const addUserError = (state) => state.user.addUserError;

export const editUserStatus = (state) => state.user.editUserStatus;
export const editUserError = (state) => state.user.editUserError;

export const companyUsers = (state) => state.user.companyUsers;
export const companyUsersLoaded = (state) => state.user.companyUsersLoaded;
export const companyUsersError = (state) => state.user.companyUsersError;

export const collectionUsers = (state) => state.user.collectionUsers;
export const collectionUsersLoaded = (state) => state.user.collectionUsersLoaded;
export const collectionUsersError = (state) => state.user.collectionUsersError;

export const addUserCollectionLoading = (state) => state.user.addUserCollectionLoading;
export const addUserCollectionError = (state) => state.user.addUserCollectionError;

export const removeUserCollectionLoading = (state) => state.user.removeUserCollectionLoading;
export const removeUserCollectionError = (state) => state.user.removeUserCollectionError;
export const deleteUserStatus = (state) => state.user.deleteUserStatus;
export const deleteUserError = (state) => state.user.deleteUserError;

export const selectEditUser = (state) => state.user.selectEditUser;

export const resetPwdLoading = (state) => state.user.resetPwdLoading;
export const resetPwdError = (state) => state.user.resetPwdError;
